import { Link } from 'react-router-dom';

const NotFound = () => (
  <section className="section not-found">
    <div className="container">
      <p className="eyebrow">Page not found</p>
      <h1>We couldn't find that page</h1>
      <Link to="/" className="button button--primary">Back to home</Link>
    </div>
  </section>
);

export default NotFound;
